/* global console __DECKAI_BASE_URL__ */
import PropTypes from "prop-types";
import * as React from "react";
import { createContext, useContext } from "react";

export const DeckAICommsContext = createContext({
  sendAction: (msg) => {
    console.log("default op", msg);
  },
});

export const useDeckAIComms = () => useContext(DeckAICommsContext);

export const DeckAICommsProvider = ({ children }) => {
  //console.log("Gridd Comms Provider created");
  const iframeRef = React.useRef();
  const sendAction = (msg) => {
    console.log("Sending action to iframe", { msg });
    try {
      if (iframeRef?.current) {
        iframeRef.current.contentWindow.postMessage(msg, __DECKAI_BASE_URL__);
      }
    } catch (err) {
      console.warn("Failed to post message to target window", err);
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <DeckAICommsContext.Provider value={{ sendAction }}>{children}</DeckAICommsContext.Provider>
      <iframe
        ref={iframeRef}
        title="deckai_embedded"
        src={__DECKAI_BASE_URL__ + "/index.html"}
        style={{ width: 0, height: 0, display: "none" }}
      />
    </div>
  );
};

DeckAICommsProvider.propTypes = {
  children: PropTypes.object,
};
